import {
  patchState,
  signalStore,
  withComputed,
  withMethods,
  withState,
} from "@ngrx/signals";
import { ApiService } from "../services";
import { computed, inject } from "@angular/core";
import { ProfileResponse } from "../models";
import { usersEndpointConfig } from "../configs";
import { Observable } from "rxjs";

import { tapResponse } from "@ngrx/operators";
import { PreferencesResponse } from "../models/api/response/preferences.response";
import { PREFERENCE_KEY } from "../enums/preference-key.enum";
import { RoleEnum } from "../enums/role.enum";
import { mockPreferencesInfo } from "./user.mock";

export type UserState = {
  partner_name?: string;
  invoice_partner_id?: string;
  country?: string;
  user_id?: string;
  phone_number?: string;
  email?: string;
  first_login?: boolean;
  has_plus_stations?: boolean;
  roles: RoleEnum[];
};

export type UserPreferences = {
  user_id: string;
  preference_key: PREFERENCE_KEY;
  active: boolean;
};

type UserInfoState = {
  user: UserState;
  preferences: UserPreferences[];
};

const initialState: UserInfoState = {
  user: {} as UserState,
  preferences: [],
};

export const UserStore = signalStore(
  { providedIn: "root" },
  withState<UserInfoState>(initialState),
  withMethods((store, apiService = inject(ApiService)) => ({
    loadUserProfile(): Observable<ProfileResponse> {
      return apiService
        .get<ProfileResponse>(usersEndpointConfig.profileUrl())
        .pipe(
          tapResponse({
            next: (userInfo) =>
              patchState(store, (state: UserInfoState) => ({
                user: { ...state.user, ...userInfo },
              })),
            error: console.error,
          }),
        );
    },
    loadUserPreferences(): Observable<PreferencesResponse> {
      return apiService
        .get<PreferencesResponse>(usersEndpointConfig.preferencesUrl())
        .pipe(
          tapResponse({
            next: (_preferencesInfo) => {
              patchState(store, { preferences: mockPreferencesInfo });
            },
            error: () => {
              patchState(store, { preferences: mockPreferencesInfo });
            },
          }),
        );
    },
    updateUserPreferences(_preferences: UserPreferences[]): void {
      const preferences = [
        {
          user_id: "123",
          preference_key: PREFERENCE_KEY.CONSENT_BANNER,
          active: false,
        },
        {
          user_id: "123",
          preference_key: PREFERENCE_KEY.HIDE_ON_DASHBOARD,
          active: false,
        },
      ];
      patchState(store, { preferences });
    },
  })),
  withComputed((store) => ({
    partnerName: computed(() => store.user.partner_name),
    isPlusStation: computed(() => !!store.user.has_plus_stations?.()),
    digitalInvoicesBannerActive: computed(() => {
      return !!store
        .preferences()
        ?.find((item) => item.preference_key === PREFERENCE_KEY.CONSENT_BANNER)
        ?.active;
    }),
    hideInvoiceBannerOnDashboard: computed(
      () =>
        !!store
          .preferences()
          ?.find(
            (item) => item.preference_key === PREFERENCE_KEY.HIDE_ON_DASHBOARD,
          )?.active,
    ),
  })),
);
